var render = function render(){var _vm=this,_c=_vm._self._c;return _c('emd-tippy',{class:['emd-action-button', _vm.tippyClassList],attrs:{"id":"feedback","tag":"button","type":'action-button',"content":'feedback'}},[_c('span',{class:['emd-text', _vm.classList]},[_c('i',{class:`uil uil-${_vm.icon}`,attrs:{"fixed-width":"","transform":"width-14"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }